var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon',_vm._b({attrs:{"name":"x16icheart"}},'icon',_vm.$attrs,false),[_c('X16icheartSvg')],1)}
var staticRenderFns = []

export { render, staticRenderFns }